export const API_BASE_URL = process.env.GATSBY_API_URL

export const FormSources = Object.freeze({
  Contact: 1,
  Distributor: 2,
})
